import { z } from "zod";

export const platformSettingsValidation = z.object({
  siteName: z
    .string()
    .trim()
    .min(2, { message: "اسم الموقع يجب أن يكون حرفين على الأقل" })
    .max(100, { message: "اسم الموقع يجب أن يكون أقل من 100 حرف" }),
  supportEmail: z
    .string()
    .trim()
    .email({ message: "الرجاء إدخال بريد إلكتروني صحيح" }),
});

export type PlatformSettingsFormValues = z.infer<
  typeof platformSettingsValidation
>;

export const securitySettingsValidation = z.object({
  sessionTimeoutMinutes: z.coerce
    .number()
    .int({ message: "الرجاء إدخال رقم صحيح" })
    .positive({ message: "يجب أن تكون القيمة أكبر من صفر" }),
  maxLoginAttempts: z.coerce
    .number()
    .int({ message: "الرجاء إدخال رقم صحيح" })
    .positive({ message: "يجب أن تكون القيمة أكبر من صفر" }),
  lockoutDurationMinutes: z.coerce
    .number()
    .int({ message: "الرجاء إدخال رقم صحيح" })
    .positive({ message: "يجب أن تكون القيمة أكبر من صفر" }),
});

export type SecuritySettingsFormValues = z.infer<
  typeof securitySettingsValidation
>;

export const emailSettingsValidation = z.object({
  emailFrom: z
    .string()
    .trim()
    .email({ message: "الرجاء إدخال بريد إلكتروني صحيح" }),
});

export type EmailSettingsFormValues = z.infer<typeof emailSettingsValidation>;

export const testEmailValidation = z.object({
  to: z.string().trim().email({ message: "الرجاء إدخال بريد إلكتروني صحيح" }),
});

export type TestEmailFormValues = z.infer<typeof testEmailValidation>;

export const allowedOriginsValidation = z.object({
  // useFieldArray requires an array of objects (spreading a primitive string
  // corrupts it into per-character keys), hence {value} wrapping over a bare string[].
  origins: z.array(
    z.object({
      value: z
        .string()
        .trim()
        .url({ message: "الرجاء إدخال رابط صحيح (https://example.com)" }),
    }),
  ),
});

export type AllowedOriginsFormValues = z.infer<
  typeof allowedOriginsValidation
>;

export const maintenanceValidation = z.object({
  enabled: z.boolean(),
  message: z.string().trim().max(500).optional(),
});

export type MaintenanceFormValues = z.infer<typeof maintenanceValidation>;
